import { WidgetCard } from '@/components/common/WidgetCard';
import { StatTile } from '@/components/common/StatTile';
import { useStats } from '@/features/dashboard/hooks/useDashboard';
import { formatCount } from '@/lib/format';
import { GlobeAltIcon } from '@/icons';

/** Domains KPI — total + verified, from mail-admin /statistics. */
export function DomainsWidget() {
  const { data, isLoading, isError, refetch } = useStats();
  return (
    <WidgetCard title="Domains" icon={GlobeAltIcon} isLoading={isLoading} isError={isError} onRetry={refetch}>
      {data && (
        <StatTile
          label="Mail domains"
          value={formatCount(data.domains)}
          accent="brand"
          sublabel={`${formatCount(data.verifiedDomains)} verified`}
        />
      )}
    </WidgetCard>
  );
}
